import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listLoading: false,
    exportLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    assignedContestList: [],
    CouponList:[]
    
}

export const callTypes = {
    list: "list",
    action: "action"
};

export const AddContestNewAssignSlice = createSlice({
    name: "AddContestNewAssign",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        assignedContestList: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },

        CouponList: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
           
            state.CouponList = entities;
        },

        emptyList: (state, action) => {
            state.error = null;
            state.entities = [];
            // state.totalCount = 0;
            state.exportData = [];
        },
    }
})